import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import './BaseChip.css';
import './ChipDeleteButton.css';
export var base = '_3mvhm30-3-15-1';
export var disabledOverride = '_3mvhm34-3-15-1';
export var emphasizedBorder = {'default':'_3mvhm31-3-15-1',condensed:'_3mvhm32-3-15-1'};
export var neutralEmphasizedOverride = '_3mvhm33-3-15-1';
export var size = {'default':'_3mvhm35-3-15-1',condensed:'_3mvhm36-3-15-1'};